<template>
	<!--首页-->
	<div class="app">
		<!--头部-->
		<navHeader></navHeader>
		<!--标题-->
		<div class="header_b">
			<img class="img-fluid" style="width: 100%;" src="../../../static/images/news.jpg" />
			<!--小导航-->
			<div class="nav_x">
				<span><img  src="../../../static/images/add.png"/></span>
				<span><a href="/">首页 </a></span>
				<span>/ 新闻资讯</span>
			</div>
		</div>
		<div class="comtit">
			<span>新闻资讯</span>
			<span>NEWS AND INFORMATION</span>
		</div>
		<!--cate-->
		<div class="cate">
			<div class="container">
				<!--类目-->
				<div class="row">
					<div class="col" v-for="(item,index) in cateData">
						<div class="cate_li" :class="curr==index?'cate_li_on':''" @click="cateTab(index)">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>
		<!--data-->
		<div class="list">
			<div class="container" style="margin-top: 10px;margin-bottom: 10px;">
				<!--类容1-->
				<div class="row" v-show="curr==0">
					<div class="col-md-6" v-for="(item,index) in listData1" @click="listDataJump(item)">
						<div class="list_li">
							<div class="row">
								<div class="left col-6"><img class="img-fluid" :src="item.img" /></div>
								<div class="right col-6" style="padding: 0 15px 0 0;">
									<div class="day d-flex justify-content-between">
										<span>7月23日</span>
										<span>2019</span>
									</div>
									<div class="cont">
										<div class="tit fontHidden1">{{item.tit}}</div>
										<div class="txt fontHidden3">{{item.txt}}</div>
										<div class="icon"><img src="../../../static/images/more.png" /></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--类容2-->
				<div class="row" v-show="curr==1">
					<div class="col-md-6" v-for="(item,index) in listData2" @click="listDataJump(item)">
						<div class="list_li" @click="">
							<div class="row">
								<div class="left col-6"><img class="img-fluid" :src="item.img" /></div>
								<div class="right col-6" style="padding: 0 15px 0 0;">
									<div class="day d-flex justify-content-between">
										<span>7月23日</span>
										<span>2019</span>
									</div>
									<div class="cont">
										<div class="tit fontHidden1">{{item.tit}}</div>
										<div class="txt fontHidden3">{{item.txt}}</div>
										<div class="icon"><img src="../../../static/images/more.png" /></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--底部-->
		<comFooter></comFooter>
	</div>
</template>
<script>
	import navHeader from '@/components/navHeader/index.vue'
	import comFooter from '@/components/comFooter/index.vue'
	export default {
		components: {
			navHeader,
			comFooter,
		},
		data() {
			return {
				curr: 0,
				cateData: [{
						name: '企业新闻'
					},
					{
						name: '行业资讯'
					},
				],
				listData1: [{
						img: "http://www.goldceramics.cn/kps01/M00/7E/EB/wKiAiVwIfuyRDHfCAAFrvIFVvCQ411.jpg",
						y: '2019',
						day: "7月23日",
						tit: '黑白灰见多了，颜值这么高的你见过么？',
						txt: "现代简约主流的搭配色彩非黑白灰莫属现代简约追求时尚简约注重空间布局与功能性的搭配黑白灰可以给整个家增添温馨气质让整个空间多了一分沉稳是这个喧嚣吵闹的城市最后净土主卧黑白灰色调加入金色点缀让整个空间雅致起来烘托出高雅简洁的气质另外，白色小灯的点缀也别具风味 ",
						imgBg: [{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfXWO31RIAAIKyFB68CM666.jpg"
							},
							{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfaSDufv_AAEwW7DB0jc129.jpg"
							},
							{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfdS52CQEAADlXl-oCl4783.jpg"
							}
						]
					},
					{
						img: "http://www.goldceramics.cn/kps01/M00/5F/5F/wKiAiVpcQJnB0_mhAAL-HfzQM5o618.png",
						y: '2019',
						day: "7月23日",  
						tit: '新璟盛集团拜访行业主流媒体 分享合力共创新局面',
						txt: "11月14日，新璟盛陶瓷集团董事长助理黄丹率市场部代表一行展开了一场以加强与媒体互动交流、探讨合作，借力媒体传播企业形象和战略思维的交流之行。分别拜访了《建材天地》、《中国陶瓷家居网》、《陶城报》、《陶瓷信息》等新闻媒体及媒体高层，谈话中，双方就宣传理念、行业及市场新闻，及双方合作意向等问题进行了深度交流，也向各大媒体预告了集团市场部近期策划的《风生水起》等品牌活动。",
						imgBg: [{
								img: "http://images02.cdn86.net/kps01/M00/57/12/wKiAiVoM3BvraZEqAAG5ES0AzN4596.jpg"
							},
							{
								img: "http://images02.cdn86.net/kps01/M00/57/12/wKiAiVoM3D6aXcmOAAHW2U__ue8072.jpg"
							}
						] 
					},
					{
						img: "http://www.goldceramics.cn/kps01/M00/51/55/wKiAiVnmyMuGM9vwAARcwDS0a8M564.jpg",
						y: '2019',
						day: "7月23日",
						tit: '璟界大成 盛启未来 ——新璟盛集团总部10月16日盛大开篇',
						txt: "2017年10月16日，金秋时刻，双喜临门，全国人民正在喜迎十九大召开，而南国陶都佛山南庄，则迎来了新璟盛集团的盛大庆典！以“璟界大成，盛启未来”为主题的新璟盛集团总部开业庆典暨四大品牌新展厅揭幕活动隆重召开！新璟盛集团董事长叶德林先生，新璟盛集团副董事长何成健先生、罗锦堂先生，新璟盛集团监事会副监事长叶永锋、叶永键先生，新璟盛集团副总裁、集团产销委主任兼集团营销管理中心总经理舒新奎先生，以及以中国建筑卫生陶瓷协会会长叶向阳先生、广东省建筑材料行业协会常务副会长、广东省陶瓷协会会长陈环先生为代表的各级行业协会；以南庄镇人民政府镇长陈辅明先生、党委委员刘玉军先生为代表的政府领导，以佛山市工商联李德书记及五区工商联主席、党组书记为代表的企业界领导及市、镇各大银行行长，新明珠企业决策委及产业链、新锦成各品牌各部门的负责人、全国近百家行业及门户网站的媒体界朋友们，以及全国六百多位新璟盛集团的经销商怀着庆贺与祝福，关怀与期待的心情从全国各地赶赴佛山共同参加这一盛会。",
						imgBg: [{
								img: "http://images02.cdn86.net/kps01/M00/52/53/wKiAiVnpxQvLLZ_zAAXkgQW72Vk784.jpg"
							},
							{
								img: ""
							}
						]
					},
					{
						img: "http://www.goldceramics.cn/kps01/M00/50/80/wKiAiVniN8XobUS3AAareYd1DLY089.jpg",
						y: '2019',
						day: "7月23日",
						tit: '风生水起 | 佛山建材家具联盟大事件',
						txt: "2017年11月17日，风生水起 | 佛山建材家具联盟大事件！万人团购招商峰会在佛山新璟盛陶瓷集团总部盛大举行！新璟盛集团董事长助理黄丹，集团营销中心副总、金利高陶瓷品牌总经理周玉敏，金利高品牌经销商、佛山市杰能企业董事长黄荣耀、蓝精灵俱乐部创始人蓝锦灵、广东星艺装饰集团佛山有限公司总经理李汉华以及美霖装饰等主办方，知名品牌国美电器、兴华商场等商家共同出席了本次招商启动会。招商会吸引了来自佛山多个区域的知名品牌商家及意向客户，共计近百人参加。在《南海电视台》、《陶城报》、《建材天地》、《中国陶瓷家居网》、《陶瓷信息》、《华夏陶瓷网》等多家知名媒体见证下，招商峰会顺利启动，面向佛山五区商家开始招商",
						imgBg: [{
								img: "http://images02.cdn86.net/kps01/M00/59/37/wKiAiVoh-zGgA5FtAAQUqYdXYDU811.jpg"
							},
							{
								img: "http://images02.cdn86.net/kps01/M00/59/37/wKiAiVoh-0D7BMczAANPo4Now_w364.jpg"
							}
						]

					},
				],
				listData2: [{
						img: "http://www.goldceramics.cn/kps01/M00/3B/4B/wKiAiVlaAmri2e7LAADCfFEATx8341.jpg",
						y: '2019',
						day: "7月23日",
						tit: '陶瓷等10行业排污许可申请与核发提上实质性日程',
						txt: "6月23至24日，2018年度国家环境保护标准项目承担单位评审会在北京召开。继火电、造纸第一批许可制改革行业的许可证申请与核发技术规范发布。钢铁、水泥、石化、焦化等13个第二批发证行业的相关技术规范也进入编制阶段之后，计划于2018年之后开展排污许可制度改革的陶瓷、印刷、家具制造、人造板、制鞋、羽毛（绒）、酒/饮料制造、食品制造加工、畜禽养殖、电池工业、汽车制造等行业的排污许可申请与核发技术规范也已提上实质性的日程。 项目承担单位采用公开征集、自愿申报、择优选取的方式确定。2017年5月，环保部已经发布了项目承担单位征集的通知，申报单位对照2018年度国家环境保护标准计划项目指南，于2017年6月12日前向环保部提交了申请材料。评审会由分管业务司组织，有29家申报单位和76家协作单位的代表参加答辩。经过专家质询和论证，环保部将择优确定每个项目的承担单位，并开始推动落实上述行业的排污许可证申请与核发技术指南编制工作。 陶瓷等10个行业的排污许可申请与核发技术规范是2018年度国家环境保护标准计划项目中环境管理规范类标准项目的重要组成部分。于同日召开承担单位评审会的还有2018年度计划中的多个环保标准项目。与排污许可制度改革相关的，还有排污单位编码规则（《污染源编码规则（试行）》hj 608-2011）的修订项目。酒/饮料制造、食品制造、喷涂、涂料油墨制造、无机化学和化学纤维制造等6个行业的自行监测技术指南等等。 排污许可制度改革的标准体系建设将有序推进，逐步完善。 附：对项目申报单位的要求 ",
						imgBg: [{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfdS52CQEAADlXl-oCl4783.jpg"
							},
							{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfaSDufv_AAEwW7DB0jc129.jpg"
							}
						]
					},{
						img: "http://www.goldceramics.cn/kps01/M00/3B/4B/wKiAiVlaAmri2e7LAADCfFEATx8341.jpg",
						y: '2019',
						day: "7月23日",
						tit: '2017陶瓷工业展圆满闭幕: “大” 板压机引发设备升级热潮',
						txt: "2017广州陶瓷工业展已经圆满闭幕。6月1日至4日，展会四天接待海内外买家共计80,639人。其中第一日28,170人，第二日29,712人，第三日19,006人，第四日3,751人。总体比2015年的观众人数有所提升。 基于今年展会规模的扩大，新之联展览公司为了给从五湖四海赶来的专业买家更好的观展体验，首先在参观登记流程、办理证件、进场等环节做了深度的优化升级，使买家们能把时间花在观展而不是排队上面。 “大” 板压机引发设备升级热潮 2017广州陶瓷工业展总面积超过十万平方米，分为九个展区，汇集了海内外逾千家参展商同台竞技。展出的热点题材有：超大吨位压机、节能环保设备、自动化及智能化装备、干法制粉技术、超大号喷墨设备、功能墨水等。 围绕着陶瓷大板生产技术，以压机为首掀起了设备升级的热潮。相应的深加工设备、喷墨设备等等都纷纷做出了相应的规格升级。 展会现场，国内以科达、恒力泰，国外以萨克米、西斯特姆、siti b&t集团为代表的几大陶机装备巨头集中展示超大吨位压机 。 科达洁能推出了kd10008、kd12008、kd16008、kd18008、kd20008机型。与此同时，kd25008、kd33008型压机在研发当中，最大分别可压制1600×3200mm及1600×3600mm大规格瓷砖。  ",
						imgBg: [{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfbm8f6a_AAFc7S_zl6c151.jpg"
							},
							{
								img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfaSDufv_AAEwW7DB0jc129.jpg"
							}
						]
					},

				]
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			cateTab(index) {
				this.curr = index
			},
			listDataJump(item) {
				let href = this.$router.resolve({
					path: '/newsDetail',
					query: {
						list: JSON.stringify(item)
					}
				})
				window.open(href.href, '_blank')
			}
		},
	}
</script>
<style scoped lang="less">
	@w: 19.2vw;
	.cate {
		.cate_li {
			border: 4/@w solid #D8D8D8;
			text-align: center;
			padding: 20/@w 0;
			color: #8A8A8A;
			font-size: 18/@w;
			cursor: pointer;
		}
		.cate_li_on {
			color: #A38061;
			font-weight: bold;
			border: 4/@w solid #A38061;
			background: rgba(209, 184, 162, 0.2);
		}
	}
	
	.list {
		margin-bottom: 40/@w;
	}
	
	.list_li {
		margin-top: 25/@w;
		cursor: pointer;
		.left {
			img {
				min-height: 240/@w;
			}
		}
		.right {
			font-size: 18/@w;
			position: relative;
			.day {
				color: #8A8A8A;
				font-size: 16/@w;
				padding-bottom: 6/@w;
				border-bottom: 1px solid #166BAB;
			}
			.tit {
				color: #8A8A8A;
				margin: 10/@w 0;
			}
			.txt {
				color: #C3BEBE;
			}
			.icon {
				position: absolute;
				bottom: 6px;
				right: 15px;
				img {
					width: 30/@w;
					min-width: 15px;
					max-width: 30px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/news/index.vue